import createGlobe from 'cobe';
import { useEffect, useRef } from 'react';

interface GlobeProps {
  className?: string;
  size?: number;
  phi?: number;
}

export const Globe = ({ className = "", size = 600, phi = 0 }: GlobeProps) => {
  const canvasRef = useRef<HTMLCanvasElement>(null);

  useEffect(() => {
    let currentPhi = phi;

    const globe = createGlobe(canvasRef.current!, {
      devicePixelRatio: 2,
      width: size * 2,
      height: size * 2,
      phi: 0,
      theta: 0,
      dark: 0,
      diffuse: 1.2,
      mapSamples: 16000,
      mapBrightness: 6,
      baseColor: [1, 1, 1],
      markerColor: [249 / 255, 115 / 255, 22 / 255], // Orange-500
      glowColor: [1, 1, 1], // White glow
      markers: [
        // Dubai
        { location: [25.2048, 55.2708], size: 0.1 },
        // London
        { location: [51.5074, 0.1278], size: 0.08 },
        // New York
        { location: [40.7128, -74.0060], size: 0.08 },
        // Singapore
        { location: [1.3521, 103.8198], size: 0.08 },
        // Hong Kong
        { location: [22.3193, 114.1694], size: 0.08 },
        // Tokyo
        { location: [35.6762, 139.6503], size: 0.08 },
      ],
      onRender: (state) => {
        // Called on every animation frame.
        // `state` will be an empty object, return updated params.
        state.phi = currentPhi;
        currentPhi += 0.003;
      },
    });

    return () => {
      globe.destroy();
    };
  }, [size, phi]);

  return (
    <div className={`relative flex items-center justify-center ${className}`}>
      <canvas
        ref={canvasRef}
        style={{ width: size, height: size, maxWidth: '100%', aspectRatio: '1' }}
        className="opacity-[0.85]"
      />
    </div>
  );
};
